import LoadMore from '../component/LoadMore'
import { withPlatform } from '../../../layout/component/PlatformContext'

export default withPlatform(LoadMore)
